import React, {useContext} from "react";

import AddressUtil from "../utils/AddressUtil";
import NetworkUtil from "../utils/NetworkUtil";
import {Web3Context} from "../../contexts/Context";

const Transaction = ({txHash, format}) => {
  const web3Context = useContext(Web3Context);
  const {networkId} = web3Context;

  if (!txHash) {
    return null;
  }

  if (NetworkUtil.isSupportedNetwork(networkId)) {
    return (
      <a href={NetworkUtil.getExplorerLink(networkId) + txHash}
         target="_blank" rel="noopener noreferrer">
        {' '}{format ? AddressUtil.formatAddress(txHash) : txHash}
      </a>
    )
  }

  return (
    <a href={txHash} target="_blank" rel="noopener noreferrer">
      {format ? AddressUtil.formatAddress(txHash) : txHash}
    </a>
  )
};

export default Transaction;